import React from "react";
import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { config } from "components/footer/data";
import { SubNav } from "./sub-nav";
import { NavItem } from "./nav-item";

export function NavColumns() {
  return (
    <SimpleGrid
      w="100%"
      columns={{ base: 2, sm: 3, md: 5 }}
      spacing="small"
      alignItems="start"
      justifyContent={{ base: "start", lg: "space-between" }}
    >
      {config.map((nav) => (
        <Flex key={nav.title} direction="column" flex={1}>
          <Text textStyle="caption1" fontWeight="bold">
            {nav.title}
          </Text>

          {nav.sub?.map((sub, index) => (
            <SubNav key={`${sub.title ?? index}`} title={sub.title}>
              {sub.nav?.map((item) => (
                <NavItem key={item.url ?? item.title} {...item}>
                  {item.title}
                </NavItem>
              ))}
            </SubNav>
          ))}
        </Flex>
      ))}
    </SimpleGrid>
  );
}
